module.exports = __webpack_public_path__ + "img/name-1978-article.027623df.jpg";